import * as React from 'react'
import { Collapse } from 'antd'
import type { CollapseProps } from 'antd'
import { Switch } from '@ui-pc'
import styles from './index.module.scss'

interface Props {
  info: any
}

const FAQ: React.FunctionComponent<Props> = (props?: any) => {
  const info = props.info || {}
  const [activeKey, setActiveKey] = React.useState([])
  const items: CollapseProps['items'] = info.qaList?.map((k: any, i) => {
    return {
      key: i + '',
      label: <span>{k.q}</span>,
      children: (
        <div
          dangerouslySetInnerHTML={{ __html: k.a }}
          className={styles.faqAnswer}></div>
      )
    }
  })

  React.useEffect(() => {
    setActiveKey([])
  }, [info.qaList])
  return (
    <Switch either={!!info.qaList?.length}>
      <div className="global-wrap">
        <div className={`${styles['faq-wrap']}`}>
          <h5 className={styles['faq-title']}>{info.title}</h5>
          <div>
            <Collapse
              activeKey={activeKey}
              items={items}
              ghost={true}
              expandIconPosition={'end'}
              expandIcon={({ isActive }) => (
                <i
                  className={`iconfont ${
                    isActive ? 'icon-pc_-new' : 'icon-a-pc_add-new'
                  }`}
                />
              )}
              className={styles['faq-collapse']}
              onChange={(key: string[]) => {
                setActiveKey(key)
              }}
            />
          </div>
        </div>
      </div>
    </Switch>
  )
}

export default FAQ
